import * as Yup from 'yup';
import { translate } from '@cashfree-intl/coherent';
import { getStringByteSize } from '../../utils/common';

const messages = {
  default: `${translate('this_field_cannot_be_left_blank')}`,
  merchantKey: `${translate('enter_the_correct_test_merchant_key')}`,
};

const validationSchema = () =>
  Yup.object({
    merchantPaytmId: Yup.string()
      .required(messages.default)
      .trim(),
    merchantPaytmKey: Yup.string()
      .required(messages.default)
      .test('merchantPaytmKey', messages.merchantKey, key => {
        const byte = getStringByteSize(key);
        return byte === 16 || byte === 24 || byte === 32;
      })
      .trim(),
  });

export default validationSchema;
